import type {OfferResult} from '../openapi';
import {PREFERRED_MENU_MEALTYPE_ID} from '#shared/constants';

export function productIsPreferredMenu(product: OfferResult) {
	return product.meal?.mealType?.id === PREFERRED_MENU_MEALTYPE_ID;
}
